import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {NetworkService} from '../network/network.service';
import {map, mergeMap} from 'rxjs/operators';
import {Link} from '../../models/link.model';
import {parseISO, isSameDay} from 'date-fns';
import {SpecialtyModel} from '../../models/provider.model';
import {Performer} from '../../models/performer.model';
import {ImageService} from '../image/image.service';

@Injectable({
  providedIn: 'root',
})
export class PerformerService {
  tasks: any[] = [];

  constructor(private network: NetworkService, private imageService: ImageService) {}

  public getTasksByDay({performerId, date}: {performerId: string; date: string}): Observable<any> {
    const link = `/api/performers/${performerId}/tasks?date=${date}`;
    const dateExist = this.tasks.find(({date: hashedDate}) => isSameDay(parseISO(hashedDate), new Date(date)));

    if (dateExist) {
      return of(dateExist.content);
    }

    return this.network.fetchResource(link).pipe(
      map(({content}: {content: any[]; links: Link[]}) => {
        this.tasks.push({date, content});
        return content;
      })
    );
  }

  public getSpecialties(): Observable<SpecialtyModel[]> {
    const link = `/api/specialties`;
    return this.network.fetchResource(link);
  }

  public getAfterVisit(taskId: string): Observable<any> {
    const url = `/api/tasks/${taskId}/afterVisit`;

    return this.network.fetchResource(url);
  }

  public getPerformer(id: string): Observable<Performer> {
    const link = `/api/performers/${id}`;

    return this.network
      .fetchResource(link)
      .pipe(mergeMap((performer: Performer) => this.imageService.addImage(performer, 'providerImage', 100)));
  }

  public getPerformerByAccountId(id: string): Observable<Performer> {
    const link = `/api/performers/find-by-account-id/${id}`;

    return this.network.fetchResource(link);
  }

  public assignProviderToNursingHome(providerId, orgId): Observable<Performer> {
    const link = `/api/performers/${providerId}/organization/${orgId}`;
    const body = {};

    return this.network.postResource(link, body);
  }

  public getPerformerLocationIds(organizationId: string): Observable<{provider: Performer; locationIds: string[]}[]> {
    const link = `/api/organizations/${organizationId}/performers/locations`;

    return this.network.fetchResource(link);
  }
}
